// extracted by mini-css-extract-plugin
export default {"back_btn_container":"BackBtn_back_btn_container__yHi8D","text_icon_container":"BackBtn_text_icon_container__ajosP","back_btn_text":"BackBtn_back_btn_text__BVvh9"};